/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PromoteTraceToDatasetPathParams = NonNullable<operations['promoteTraceToDataset']['parameters']['path']>;

export type PromoteTraceToDatasetRequestBody = OperationRequestBodyContent<operations['promoteTraceToDataset']>;

export interface Input extends PromoteTraceToDatasetPathParams {
  apiVersion?: string;
  body: PromoteTraceToDatasetRequestBody;
}

export async function promoteTraceToDataset(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/internal/projects/{projKey}/environments/{envKey}/datasets/{datasetId}/rows', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
